import React from 'react';
import Grid from '@powerednow/components/Grid/Grid';
import '@powerednow/components/theme/stylesheet';
import Box from '@powerednow/components/Box/Box';
import LabelValuePair from '@powerednow/components/LabelValuePair/LabelValuePair';
import Paper from '@powerednow/components/Paper/Paper';
import textUtils from '@powerednow/shared/modules/utilities/textUtils';
import { styled, Theme } from '@mui/material/styles';
import { Utilities } from 'FieldServices/singletons/Utilities';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const QuoteCardPaper = styled(Paper, {
    name: 'QuoteCardPaper',
    slot: 'root',
})(({ onClick }) => ({
    backgroundColor: '#ecf0f1',
    '&:hover': {
        backgroundColor: '#dde4e6',
    },
    cursor: onClick ? 'pointer' : undefined,
}));

const useStyles = makeStyles<Theme>(createStyles({
    preventOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        marginRight: '20px !important', // !important: css bleeding from ext
    },
}));

function QuoteCard({ quote, onClick }) {
    const classes = useStyles();

    const docLines = quote.displayedSummaries.map((item, index) => {
        const parsed = new DOMParser().parseFromString(item, 'text/html');
        return <p key={index} className={classes.preventOverflow}>{parsed.documentElement.textContent}</p>;
    });

    return (
        <QuoteCardPaper onClick={onClick}>
            <Grid container>
                <Grid item xs={7}>
                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <Box component="h3" sx={{ color: 'secondary.main' }}>{quote.displaynumber}</Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Box component="span" fontSize={theme => theme.poweredNowTypography.fontSize.base} color="backgroundColor">
                                {Utilities.localisedString(quote.displayStatusPrompt.promptId, quote.displayStatusPrompt.defaultValue)}
                            </Box>
                        </Grid>
                    </Grid>
                    <LabelValuePair label="Summary" value={docLines} labelWidth={12} valueWidth={12} />
                </Grid>
                <Grid item xs={5}>
                    <LabelValuePair
                        label="Created"
                        value={textUtils.formatDateTime(quote.dt_created)}
                        labelWidth={6.5}
                        valueWidth={5.5}
                        colSecondAlign="right"
                    />
                    <LabelValuePair
                        label="Already invoiced"
                        value={textUtils.formatMoney(quote.alreadyInvoicedAmount)}
                        labelWidth={6.5}
                        valueWidth={5.5}
                        colSecondAlign="right"
                    />
                    <LabelValuePair
                        label="Amount to go"
                        value={textUtils.formatMoney(quote.total - quote.alreadyInvoicedAmount)}
                        labelWidth={6.5}
                        valueWidth={5.5}
                        colSecondAlign="right"
                        color={quote.isFullyInvoiced ? 'success.main' : undefined}
                    />
                    <LabelValuePair
                        label="Accepted amount"
                        value={textUtils.formatMoney(quote.accepted)}
                        labelWidth={6.5}
                        valueWidth={5.5}
                        colSecondAlign="right"
                    />
                </Grid>
            </Grid>
        </QuoteCardPaper>
    );
}

export default QuoteCard;
